module.exports = __webpack_public_path__ + "static/media/varka-main-1.06640230.png";